// dependency-graph-ignore-file
import { addEntryBelowMenuItem } from '../items/add-entry-below-menu-item.tsx';
import { addFieldRightMenuItem } from '../items/add-field-right-menu-item.tsx';
import { askRovoMenuItem } from '../items/ask-rovo-menu-item.tsx';
import { clearValuesMenuItem } from '../items/clear-values-menu-item.tsx';
import { commentsMenuItem } from '../items/comments-menu-item.tsx';
import { copyValueLinkMenuItem } from '../items/copy-value-link-menu-item.tsx';
import { deleteCurrentColumnMenuItem } from '../items/delete-current-column-menu-item.tsx';
import { deleteCurrentRowMenuItem } from '../items/delete-current-row-menu-item.tsx';
import {
  type MergedActionsAPI,
  type SelectionsEffectCellContextMenuContext,
  type MenuContentItemFactory
} from '../types.ts';

const skip = () => null;

export function createSelectValueContextMenuItems(
  context: SelectionsEffectCellContextMenuContext,
  actions: MergedActionsAPI
): MenuContentItemFactory[] {
  return [
    askRovoMenuItem(context, actions, skip),
    { type: 'separator' },
    commentsMenuItem(context, actions, skip),
    copyValueLinkMenuItem(context, actions, skip),
    { type: 'separator' },
    addFieldRightMenuItem(context, actions, skip),
    addEntryBelowMenuItem(context, actions, skip),
    clearValuesMenuItem(context, actions, skip),
    deleteCurrentColumnMenuItem(context, actions, skip),
    deleteCurrentRowMenuItem(context, actions, skip)
  ];
}
